import { IBaseDocument } from '@shared/types'
import { IDocumentPackage, IDocumentUploadResult, IFirmaResult } from '@/types'

export class DocumentService {
	protected basePath: string

	constructor(basePath: string) {
		this.basePath = basePath
	}

	async getDocuments(): Promise<IBaseDocument[]> {
		try {
			const response = await fetch(`${this.basePath}/documents`)
			if (!response.ok) throw new Error('Error al obtener documentos')
			return await response.json()
		} catch (error) {
			console.error('Error en getDocuments:', error)
			throw error
		}
	}

	async getPackages(): Promise<IDocumentPackage[]> {
		try {
			const response = await fetch(`${this.basePath}/packages`)
			if (!response.ok) throw new Error('Error al obtener paquetes')
			return await response.json()
		} catch (error) {
			console.error('Error en getPackages:', error)
			throw error
		}
	}

	async uploadDocument(file: File): Promise<IDocumentUploadResult> {
		try {
			const formData = new FormData()
			formData.append('file', file)

			const response = await fetch(`${this.basePath}/upload`, {
				method: 'POST',
				body: formData
			})

			if (!response.ok) throw new Error('Error al subir documento')
			return await response.json()
		} catch (error) {
			console.error('Error en uploadDocument:', error)
			throw error
		}
	}

	async signDocument(docId: string): Promise<IFirmaResult> {
		try {
			const response = await fetch(`${this.basePath}/sign/${docId}`, {
				method: 'POST'
			})

			if (!response.ok) throw new Error('Error al firmar documento')
			return await response.json()
		} catch (error) {
			console.error('Error en signDocument:', error)
			throw error
		}
	}

	async validateDocument(docId: string): Promise<IBaseDocument> {
		try {
			const response = await fetch(`${this.basePath}/validate/${docId}`, {
				method: 'POST'
			})

			if (!response.ok) throw new Error('Error al validar documento')
			return await response.json()
		} catch (error) {
			console.error('Error en validateDocument:', error)
			throw error
		}
	}

	async deleteDocument(docId: string): Promise<void> {
		try {
			const response = await fetch(`${this.basePath}/documents/${docId}`, {
				method: 'DELETE'
			})

			if (!response.ok) throw new Error('Error al eliminar documento')
		} catch (error) {
			console.error('Error en deleteDocument:', error)
			throw error
		}
	}
}
